var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradebookNotPostedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    rx: 12,
    fill: "#F9E4F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 17C19.5178 17 19.9375 16.5803 19.9375 16.0625C19.9375 15.5447 19.5178 15.125 19 15.125C18.4822 15.125 18.0625 15.5447 18.0625 16.0625C18.0625 16.5803 18.4822 17 19 17Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13.25V12.625C20.3805 12.625 21.5 11.6453 21.5 10.4375C21.5 9.22969 20.3805 8.25 19 8.25C17.6195 8.25 16.5 9.22969 16.5 10.4375V10.75",
    stroke: "#344054",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19.5C23.1421 19.5 26.5 16.1421 26.5 12C26.5 7.85786 23.1421 4.5 19 4.5C14.8579 4.5 11.5 7.85786 11.5 12C11.5 16.1421 14.8579 19.5 19 19.5Z",
    stroke: "#344054",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradebookNotPostedIcon);
export default __webpack_public_path__ + "static/media/gradebook-not-posted-icon.fe1e9d3ab2a9677d1b64be62ec88a834.svg";
export { ForwardRef as ReactComponent };